import React from "react";
import { useSelector } from "react-redux";
import { useDictionary } from "hooks";
import { isNonEmptyString, isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import Modal from "@cayuse/shared-react.components.modal";
import Button from "@cayuse/shared-react.components.button";
import Dropdown from "@cayuse/shared-react.components.dropdown";
import { tenantSelectors } from "store/selectors";

import styles from "./styles.css";


const defaultOptions = [
	{
		key: "no-cost-time-extension",
		value: "No Cost Time Extension",
		text: "No Cost Time Extension"
	},
	{
		key: "new-funding-increment",
		value: "New Funding Increment",
		text: "New Funding Increment"
	}
];

export const ModifyFormModal = ({ modifyFormModalData, isSubaward }) => {
	const dictionary = useDictionary("modifications.common.modal.modify");
	const buttonText = useDictionary("modifications.common.buttons");
	const {
		formType,
		isLoading,
		modifyFormModalVisible,
		onModifyFormClose,
		onModifyFormContinue,
		reason,
		setReason
	} = modifyFormModalData;
	const { modificationTypes, subawardModificationTypes } = useSelector(tenantSelectors.tenant);

	const getModificationTypeOptions = () => {
		const modificationList = isSubaward ? subawardModificationTypes.modifications : modificationTypes.modifications;
		if(isNonEmptyArray(modificationList)) {
			return modificationList.filter(modification => modification.active)
				.map(modification => {
					return modification = {
						key: modification.value,
						value: modification.value,
						text: modification.value
					};
				});
		}
	};

	const displayModifyFormContent = () => {
		return (
			<Modal.Content>
				<p className={`${styles.label} ${styles.bold}`}>{dictionary.label || "Reason For Modification"}</p>
				<div className={styles.modificationTypeWrapper}>
					<Dropdown
						className={styles.modificationType}
						onChange={(event, { value }) => setReason(value)}
						openOnFocus={false}
						options={getModificationTypeOptions() || defaultOptions} //TODO: remove mock options when Modification types start coming back from BE
						placeholder={dictionary.dropdownPlaceholder}
						search
						value={reason}
					/>
				</div>
			</Modal.Content>
		);
	};

	return (
		<Modal open={modifyFormModalVisible} onClose={onModifyFormClose} ariaLabel={`${dictionary.title || "Modify Form:"} ${formType}`}>
			<Modal.Header className="ui header whiteOnBlue">
				<h2>{dictionary.title || "Modify Form:"} {formType}</h2>
			</Modal.Header>
			{displayModifyFormContent()}
			<Modal.Actions>
				<div className="field">
					<Button className={styles.cancelButton} secondary onClick={onModifyFormClose}>
						{buttonText.cancel || "Cancel"}
					</Button>
					<Button
						busy={isLoading}
						onClick={onModifyFormContinue}
						disabled={!isNonEmptyString(reason) || isLoading}
					>
						{buttonText.continue || "Continue"}
					</Button>
				</div>
			</Modal.Actions>
		</Modal>
	);
};


export default ModifyFormModal;
